export enum NavItemId {
  Home,
  HighGuide,
  Products,
  Locations,
  Templates,
  Menus,
  Displays,
  Settings,
  Profile,
  Help,
  CurrentLocation,
  SignOut
}
